import React from "react";

const MergeIcon = ({ size = 345, h = "10", fill = "#4361E9" }) => {
  // create the height and width based on the size prop, default width is 345 and height is 231
  const width = (size / 345) * 345;
  const height = (size / 345) * 231;
  return (
    <svg
      width="25"
      height="17"
      viewBox="0 0 25 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.10417 7.25814C4.45611 7.25814 5.55208 6.16217 5.55208 4.81022C5.55208 3.45827 4.45611 2.3623 3.10417 2.3623C1.75222 2.3623 0.65625 3.45827 0.65625 4.81022C0.65625 6.16217 1.75222 7.25814 3.10417 7.25814Z"
        fill="white"
      />
      <path
        d="M3.10417 14.6029C4.45611 14.6029 5.55208 13.5069 5.55208 12.1549C5.55208 10.803 4.45611 9.70703 3.10417 9.70703C1.75222 9.70703 0.65625 10.803 0.65625 12.1549C0.65625 13.5069 1.75222 14.6029 3.10417 14.6029Z"
        fill="white"
      />
      <path d="M7.875 8.48242H11.5469H7.875Z" fill="black" />
      <path
        d="M7.875 8.48242H11.5469"
        stroke="white"
        stroke-width="1.04098"
        stroke-linecap="round"
      />
      <path
        d="M10.3203 6.03564L12.7682 8.48356L10.3203 10.9315"
        stroke="white"
        stroke-width="1.04098"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.8623 12.8358C22.3232 12.8358 24.3183 10.8408 24.3183 8.37983C24.3183 5.91885 22.3232 3.92383 19.8623 3.92383C17.4013 3.92383 15.4062 5.91885 15.4062 8.37983C15.4062 10.8408 17.4013 12.8358 19.8623 12.8358Z"
        fill="white"
      />
    </svg>
  );
};

export default MergeIcon;
